const indicatorConstants = {
    SET_INDICATOR_REQUEST:'SET_INDICATOR_REQUEST',
    SET_INDICATOR_SUCCESS:'SET_INDICATOR_SUCCESS',
    SET_INDICATOR_FAILURE:'SET_INDICATOR_FAILURE',

    CLEAR: 'INDICATOR_CLEAR',
}

export default indicatorConstants